export default "__VITE_ASSET__OsooL8pD__"